import { useLayoutEffect, useRef, useState } from 'react';
import { IMediaQueryOptions } from '../types/common.types';

//Using a global variable to set media
let mediaOptions: IMediaQueryOptions;

export const useScreenMediaQuery = (screenType: keyof IMediaQueryOptions) => {
	const mediaQuery = useRef<MediaQueryList>();
	const [isActive, setIsActive] = useState(false);

	useLayoutEffect(() => {
		mediaQuery.current = window.matchMedia(mediaOptions[screenType]);
		setIsActive(mediaQuery.current.matches);

		const updateStatus = (queryListEvent: MediaQueryListEvent) => {
			setIsActive(queryListEvent.matches);
		};
		mediaQuery.current.addEventListener('change', updateStatus);

		return () => {
			mediaQuery.current?.removeEventListener('change', updateStatus);
		};
	}, []);

	return isActive;
};

useScreenMediaQuery.setMediaOptions = (selectedOptions: IMediaQueryOptions) => {
	mediaOptions = { ...selectedOptions };
};
